import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from '../../../../util/reactIntl';
import { NamedLink } from '../../../../components';
import css from './OwnerGalleryTabEmptyState.module.css';

const OwnerGalleryTabEmptyState = ({ className }) => (
  <div className={classNames(css.root, className)}>

    <div className={css.titleWrapper}>
      <h2 className={css.title}>
        <FormattedMessage
          id="StoreProfilePage.tabs.gallery.ownerEmpty.title"
          defaultMessage="Showcase Gallery"
        />
      </h2>
      <span className={css.itemCount}>
        <FormattedMessage
          id="StoreProfilePage.tabs.gallery.ownerEmpty.subtitle"
          defaultMessage="0 Items"
        />
      </span>
    </div>

    <div className={css.contentWrapper}>
      <div className={css.art} aria-hidden="true">
        <i className={classNames('ri-gallery-view-2', css.artIcon)} />
      </div>
      <p className={css.description}>
        <FormattedMessage
          id="StoreProfilePage.tabs.gallery.ownerEmpty.description"
          defaultMessage="Upload photos or videos to showcase your store and items."
        />
      </p>
      <NamedLink name="MediaLibraryPage" className={css.cta}>
        <FormattedMessage
          id="StoreProfilePage.tabs.gallery.ownerEmpty.cta"
          defaultMessage="Upload Media"
        />
        <i className={classNames('ri-arrow-right-up-line', css.ctaArrow)} aria-hidden />
      </NamedLink>
    </div>
  </div>
);

OwnerGalleryTabEmptyState.propTypes = {
  className: PropTypes.string,
};

export default OwnerGalleryTabEmptyState;
